

module.exports = __webpack_require__.stylable.create(
    "PendingGroupList2576414715",
    {"classes":{"root":"PendingGroupList2576414715__root","groupCard":"PendingGroupList2576414715__groupCard","title":"PendingGroupList2576414715__title","badge":"PendingGroupList2576414715__badge","mobileLabel":"PendingGroupList2576414715__mobileLabel","mobileCta":"PendingGroupList2576414715__mobileCta"},"vars":{},"stVars":{"cardBackground":"\"color(fallback(--cardBackgroundColor, color-1))\""},"keyframes":{}},
    "",
    4,
    "PendingGroupList2576414715",
    null
);
